/* ===========================================================================
   EXCENTRED · TAP TO DROP · Runde 70 (11.10.2026)
   Das Pop-up selbst ist ein Privy-Display (je Sprache eins: DE, PL, EN, IT).
   Privy übernimmt Auslöser, Anmeldung, Einwilligung und Tags.
   Dieses Skript setzt nur das Spiel und die Code-Anzeige in die beiden
   Platzhalter („Spacer“) des Displays ein:
     Schritt 1  …5e02  Spielbrett, danach Gewinn + E-Mail-Feld freigeben
     Schritt 2  …5e08  Code anzeigen, im Warenkorb aktivieren
   Erkannt wird das Display an diesen Platzhaltern, nicht an der Display-ID.
   Kopien in Privy (A/B-Test, neue Sprache) funktionieren damit ohne Änderung.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__exDrop) return;
  window.__exDrop = true;

  var CFG = window.EX_DROP || {};
  var U = '7c1d2a10-4b1e-4c55-9f3e-1a2b3c4d5e';
  var SL = {
    head: 'TextElement-' + U + '01-slot',
    game: 'SpacerElement-' + U + '02-slot',
    mail: 'EmailFieldElement-' + U + '03-slot',
    btn: 'ButtonElement-' + U + '04-slot',
    legal: 'TextElement-' + U + '05-slot',
    code: 'SpacerElement-' + U + '08-slot'
  };

  /* Codes nicht im Klartext (schützt vor einfachem Suchen im Quelltext) */
  var ENC = { p20: 'UVg3Sy0wMlBPUkQ=', p15: 'SFcyVC01MVBPUkQ=', p10: 'UlQ5Qi0wMVBPUkQ=', ship: 'V04zUi1FRVJGUE9SRA==' };
  function code(k) {
    try { return atob(ENC[k]).split('').reverse().join(''); } catch (e) { return ''; }
  }

  var SLOTS = [
    { k: 'p20', sp: false }, { k: 'ship', sp: true }, { k: 'p10', sp: false }, { k: 'p15', sp: false },
    { k: 'p10', sp: false }, { k: 'ship', sp: true }, { k: 'p20', sp: false }
  ];
  /* Brett (unverändert): 20 % trifft im Schnitt 6,7 %, 15 % 20,8 %, 10 % 43,3 %, Versand frei 29,2 %.
     Jede Wurfposition hat praktisch denselben Erwartungswert (11,1 bis 11,1 %). */
  var SPEC = { '1:5': 'K', '1:7': 'K', '2:2': 'R', '2:10': 'L', '3:1': 'R', '3:11': 'L', '4:6': 'K', '5:3': 'R', '5:9': 'L', '6:2': 'R', '6:10': 'L' };
  var ROWS = 8, N = 7, HALF = 12;

  /* ------------------------------ Sprache ------------------------------ */
  var LANG = String(CFG.lang || (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var TX = {
    de: {
      hint: 'Drag &amp; Drop', drop: 'DROP BALL', busy: '…', won: 'UNLOCKED',
      h2: 'NUR NOCH DEINE MAIL.', lead: 'Dein Code erscheint sofort – hier im Fenster.',
      act: 'Dein Code ist aktiviert und wird im Checkout automatisch abgezogen.',
      clab: 'DEIN CODE', copy: 'KOPIEREN', copied: 'KOPIERT',
      min: 'Ab {v} Bestellwert', once: 'einmal pro Kunde', ca: 'ca. ',
      priv: 'Datenschutz', slider: 'Wurfposition'
    },
    en: {
      hint: 'Drag &amp; Drop', drop: 'DROP BALL', busy: '…', won: 'UNLOCKED',
      h2: 'ONE STEP LEFT: YOUR EMAIL.', lead: 'Your code appears right here.',
      act: 'Your code is active and comes off automatically at checkout.',
      clab: 'YOUR CODE', copy: 'COPY', copied: 'COPIED',
      min: 'Orders from {v}', once: 'once per customer', ca: 'approx. ',
      priv: 'Privacy', slider: 'Drop position'
    },
    pl: {
      hint: 'Drag &amp; Drop', drop: 'DROP BALL', busy: '…', won: 'UNLOCKED',
      h2: 'ZOSTAŁ TYLKO MAIL.', lead: 'Twój kod pojawi się od razu – tutaj.',
      act: 'Twój kod jest aktywny i zostanie automatycznie odliczony przy kasie.',
      clab: 'TWÓJ KOD', copy: 'KOPIUJ', copied: 'SKOPIOWANO',
      min: 'Od {v} wartości zamówienia', once: 'raz na klienta', ca: 'ok. ',
      priv: 'Prywatność', slider: 'Pozycja rzutu'
    },
    it: {
      hint: 'Drag &amp; Drop', drop: 'DROP BALL', busy: '…', won: 'UNLOCKED',
      h2: 'MANCA SOLO LA TUA EMAIL.', lead: 'Il tuo codice appare subito qui.',
      act: 'Il tuo codice è attivo e viene scalato automaticamente al checkout.',
      clab: 'IL TUO CODICE', copy: 'COPIA', copied: 'COPIATO',
      min: 'Ordini da {v}', once: 'una volta per cliente', ca: 'ca. ',
      priv: 'Privacy', slider: 'Posizione di lancio'
    }
  };
  var T = TX[LANG] || TX.en;
  var LAB = { p20: '20%', p15: '15%', p10: '10%', ship: 'FREE<br>SHIPPING' };

  /* --------------------------- Hilfsfunktionen -------------------------- */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var KEY = 'ex-drop.prize';
  var gewinn = null;
  function merken(k) { gewinn = k; try { sessionStorage.setItem(KEY, k); } catch (e) {} }
  function holen() { if (gewinn) return gewinn; try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }

  function marketingErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return false;
      return cp.marketingAllowed() === true;
    } catch (e) { return false; }
  }
  function track(name, data) {
    data = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: 'x_drop_' + name, x_drop_sprache: LANG };
      for (var k in data) p[k] = data[k];
      window.dataLayer.push(p);
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function' && marketingErlaubt()) {
        window.fbq('trackCustom', 'XDrop' + name.charAt(0).toUpperCase() + name.slice(1), data);
      }
    } catch (e) {}
  }

  function minText() {
    var eur = Number(CFG.minEUR || 0);
    if (!eur) return '';
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var active = cur.active || 'EUR';
    var rate = parseFloat(cur.rate || '1') || 1;
    var val = active === 'EUR' ? eur : Math.ceil(eur * rate);
    var s;
    try {
      s = new Intl.NumberFormat(LANG, { style: 'currency', currency: active, maximumFractionDigits: 0 }).format(val);
    } catch (e) { s = val + ' ' + active; }
    return T.min.replace('{v}', (active === 'EUR' ? '' : T.ca) + s);
  }

  /* ------------------------------- Styles ------------------------------- */
  var CSS = ''
  /* Zustand steht an unserem eigenen Element (Privy/React fasst es nicht an), :has() wirkt auf die Privy-Slots */
  + '[data-testid="popup-layout-container"]:has(.xdw[data-xd-state="pre"])>.' + SL.mail + ','
  + '[data-testid="popup-layout-container"]:has(.xdw[data-xd-state="pre"])>.' + SL.btn + ','
  + '[data-testid="popup-layout-container"]:has(.xdw[data-xd-state="pre"])>.' + SL.legal + '{display:none!important}'
  + '[data-testid="popup-layout-container"]:has(.xdw[data-xd-state="won"])>.' + SL.head + '{display:none!important}'
  + '.xdw{font-family:inherit;text-align:left;color:#414140;-webkit-font-smoothing:antialiased;width:100%;line-height:1.4}'
  + '.xdw *{box-sizing:border-box}'
  + '.xdw [hidden]{display:none!important}'
  + '.xdw .rail{position:relative;height:56px;background:linear-gradient(180deg,#F9F8F5,#F1EFEA);border:1px solid #D3CEC5;border-bottom:0;touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}'
  + '.xdw .rail.grab{cursor:grabbing}.xdw .rail.done{cursor:default}'
  + '.xdw .rail:after{content:"";position:absolute;left:0;right:0;bottom:0;border-bottom:1px dashed #D3CEC5}'
  + '.xdw .rail:focus-visible{outline:2px solid #FFC400;outline-offset:2px}'
  + '.xdw .tick{position:absolute;bottom:0;width:1px;height:7px;background:#D3CEC5;transform:translateX(-50%);pointer-events:none;transition:opacity .2s}'
  + '.xdw .rail.done .tick{opacity:0}'
  + '.xdw .thr{position:absolute;top:34%;width:20px;height:20px;margin:-10px 0 0;transform:translateX(-50%);border-radius:50%;background:radial-gradient(circle at 34% 28%,#4C4B46,#030302 62%);box-shadow:0 0 0 3px rgba(255,196,0,.35),0 3px 7px rgba(3,3,2,.22);transition:left .1s ease-out,transform .15s,opacity .2s,box-shadow .15s}'
  + '.xdw .rail.grab .thr{box-shadow:0 0 0 7px rgba(255,196,0,.5),0 3px 7px rgba(3,3,2,.22);transform:translateX(-50%) scale(1.12)}'
  + '.xdw .rail.done .thr{opacity:0;transform:translateX(-50%) scale(.6)}'
  + '.xdw .hint{position:absolute;left:0;right:0;bottom:4px;text-align:center;font-size:9px;letter-spacing:1.6px;text-transform:uppercase;color:#8C8A85;pointer-events:none;opacity:0;transition:opacity .45s}'
  + '.xdw .hint.show{opacity:1}.xdw .rail.done .hint{opacity:0}'
  + '.xdw .hand{position:absolute;top:34%;left:50%;width:25px;height:33px;margin:-2px 0 0 -11.5px;opacity:0;pointer-events:none;z-index:4}'
  + '.xdw .hand svg{display:block;width:25px;height:33px}'
  + '.xdw .rail.demo .thr{animation:xdThr 4.4s cubic-bezier(.4,.05,.55,.95) 3}'
  + '.xdw .rail.demo .hand{animation:xdHand 4.4s cubic-bezier(.4,.05,.55,.95) 3}'
  + '.xdw .rail.demo~.board .gd{animation:xdGd 4.4s cubic-bezier(.4,.05,.55,.95) 3}'
  + '@keyframes xdThr{0%,7%{left:50%;transform:translateX(-50%) scale(1)}13%{left:50%;transform:translateX(-50%) scale(1.12)}38%{left:21.43%;transform:translateX(-50%) scale(1.12)}64%{left:78.57%;transform:translateX(-50%) scale(1.12)}82%{left:50%;transform:translateX(-50%) scale(1.12)}89%,100%{left:50%;transform:translateX(-50%) scale(1)}}'
  + '@keyframes xdHand{0%{left:50%;opacity:0;transform:translateY(16px)}7%{left:50%;opacity:.9;transform:translateY(5px)}13%{left:50%;opacity:1;transform:translateY(0)}38%{left:21.43%;opacity:1;transform:translateY(0)}64%{left:78.57%;opacity:1;transform:translateY(0)}82%{left:50%;opacity:1;transform:translateY(0)}89%{left:50%;opacity:.9;transform:translateY(-9px)}100%{left:50%;opacity:0;transform:translateY(-17px)}}'
  + '@keyframes xdGd{0%,13%{left:50%}38%{left:21.43%}64%{left:78.57%}82%,100%{left:50%}}'
  + '.xdw .board{position:relative;height:220px;background:linear-gradient(180deg,#F9F8F5,#EEECE7);border:1px solid #D3CEC5;border-bottom:0;overflow:hidden;box-shadow:inset 0 7px 12px -9px rgba(3,3,2,.3)}'
  + '.xdw .peg{position:absolute;width:6px;height:6px;background:#D3CEC5;transform:translate(-50%,-50%) rotate(45deg);transition:transform .12s,background .12s}'
  + '.xdw .peg.kk{width:11px;height:11px;background:#FFC400;box-shadow:0 0 0 1px rgba(3,3,2,.18)}'
  + '.xdw .peg.fl{background:#030302;transform:translate(-50%,-50%) rotate(45deg) scale(1.7)}'
  + '.xdw .wg{position:absolute;width:0;height:0;transform:translate(-50%,-50%);border-top:7px solid transparent;border-bottom:7px solid transparent;transition:transform .12s}'
  + '.xdw .wg.r{border-left:13px solid #030302;margin-left:-3px}.xdw .wg.l{border-right:13px solid #030302;margin-left:3px}'
  + '.xdw .wg.fl{transform:translate(-50%,-50%) scale(1.45)}'
  + '.xdw .ball{position:absolute;width:18px;height:18px;background:radial-gradient(circle at 34% 28%,#4C4B46,#030302 62%);border-radius:50%;transform:translate(-50%,-50%);z-index:3;opacity:0;box-shadow:0 0 0 2px rgba(255,196,0,.45),0 3px 8px rgba(3,3,2,.28)}'
  + '.xdw .ball.on{opacity:1}'
  + '.xdw .tr{position:absolute;width:9px;height:9px;border-radius:50%;background:#030302;opacity:.22;transform:translate(-50%,-50%);transition:opacity .5s linear,width .5s,height .5s;z-index:2;pointer-events:none}'
  + '.xdw .tr.go{opacity:0;width:3px;height:3px}'
  + '.xdw .gd{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:linear-gradient(180deg,rgba(255,196,0,.95),rgba(255,196,0,.06));transition:left .1s ease-out,opacity .2s;z-index:1}'
  + '.xdw .fin{position:absolute;bottom:0;width:1px;height:16px;background:#D3CEC5;z-index:1}'
  + '.xdw .slots{display:grid;grid-template-columns:repeat(7,1fr);border:1px solid #D3CEC5}'
  + '.xdw .slot{border-right:1px solid #D3CEC5;padding:10px 1px;text-align:center;background:#fff;display:flex;align-items:center;justify-content:center;min-height:42px;position:relative;overflow:hidden}'
  + '.xdw .slot:last-child{border-right:0}'
  + '.xdw .slot:before{content:"";position:absolute;left:0;right:0;bottom:0;height:0;background:#FFC400;transition:height .35s cubic-bezier(.2,.8,.3,1)}'
  + '.xdw .slot.hit:before{height:100%}'
  + '.xdw .slot b{position:relative;z-index:1;display:block;font-size:12.5px;line-height:14px;color:#030302;letter-spacing:-.3px;font-weight:700;transition:transform .3s cubic-bezier(.2,.8,.3,1)}'
  + '.xdw .slot.hit b{transform:scale(1.09)}'
  + '.xdw .slot.sp b{font-size:7.5px;line-height:10px;letter-spacing:0}'
  + '.xdw .go{border:0;background:#030302;color:#fff;font-family:inherit;font-weight:700;font-size:13px;letter-spacing:2px;text-transform:uppercase;height:52px;padding:0 14px;width:100%;cursor:pointer;margin-top:14px;display:block;text-align:center;border-radius:0}'
  + '.xdw .go:hover:not(:disabled){background:#1C1C1A}'
  + '.xdw .go:disabled{background:#D3CEC5;color:#8C8A85;cursor:default}'
  + '.xdw .go:focus-visible,.xdw .cp:focus-visible{outline:2px solid #FFC400;outline-offset:2px}'
  + '.xdw .prize{background:#0A0A0A;background-image:radial-gradient(130% 100% at 50% -10%,rgba(255,196,0,.16),rgba(255,196,0,0) 58%);padding:20px 16px;text-align:center}'
  + '.xdw .prize .a{font-size:10px;line-height:14px;letter-spacing:2.4px;text-transform:uppercase;color:#FFC400;font-weight:600}'
  + '.xdw .prize .b{font-size:46px;line-height:46px;letter-spacing:-1.5px;color:#FFC400;margin-top:6px;font-weight:700}'
  + '.xdw .prize .b.sm{font-size:26px;line-height:28px;letter-spacing:-.4px}'
  + '.xdw h3{font-family:inherit;font-size:21px;line-height:24px;letter-spacing:-.4px;color:#030302;font-weight:700;margin:18px 0 0;text-transform:none}'
  + '.xdw p.l{font-size:13px;line-height:20px;color:#414140;margin:6px 0 0}'
  + '.xdw .code{border:1px dashed #030302;background:#F5F3EF;padding:14px 14px 12px;margin-top:14px;display:flex;align-items:center;gap:12px}'
  + '.xdw .code .c{flex:1 1 auto;min-width:0}'
  + '.xdw .code .a{font-size:10px;line-height:14px;letter-spacing:2px;text-transform:uppercase;color:#8C8A85}'
  + '.xdw .code .b{font-size:19px;line-height:24px;letter-spacing:1px;color:#030302;margin-top:3px;word-break:break-all;font-weight:700;user-select:all;-webkit-user-select:all}'
  + '.xdw .cp{flex:0 0 auto;border:1px solid #030302;background:#fff;color:#030302;font-family:inherit;font-size:10px;line-height:14px;font-weight:700;letter-spacing:1.6px;padding:9px 10px;cursor:pointer;border-radius:0}'
  + '.xdw .cond{font-size:10.5px;line-height:15px;color:#8C8A85;margin:8px 0 0}'
  + '.' + SL.legal + ' .privy-widget-text{display:block!important}'
  + '.' + SL.mail + ' input:focus{outline:none!important;box-shadow:inset 0 0 0 1px #030302!important}'
  + '.xd-legal-a{color:inherit!important;text-decoration:underline!important;text-underline-offset:2px;display:inline!important}'
  + '@media (max-width:400px){.xdw .board{height:196px}}'
  + '@media (max-height:700px){.xdw .board{height:168px}.xdw .rail{height:48px}.xdw .prize{padding:14px 12px}.xdw .prize .b{font-size:38px;line-height:40px}}'
  + '@media (prefers-reduced-motion:reduce){.xdw .ball,.xdw .peg,.xdw .wg,.xdw .tr,.xdw .slot:before,.xdw .thr{transition:none!important}.xdw .rail.demo .thr,.xdw .rail.demo .hand,.xdw .rail.demo~.board .gd{animation:none!important}}';

  function styles() {
    if (document.getElementById('xd-css')) return;
    var st = document.createElement('style');
    st.id = 'xd-css';
    st.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(st);
  }

  /* ------------------------------ Mathematik ---------------------------- */
  function ref(h) { while (h < 0 || h > HALF) { if (h < 0) h = -h; if (h > HALF) h = 2 * HALF - h; } return h; }
  var INSET = 100 / (N * 2), SPAN = 100 - 2 * INSET;
  function xOf(h) { return INSET + (h / HALF) * SPAN; }
  function yOf(r) { return ((r + 1) / (ROWS + 1)) * 100; }

  /* --------------------- Datenschutz-Wort verlinken --------------------- */
  function legalLink(grid) {
    var box = grid.querySelector('.' + SL.legal + ' .privy-widget-text') || grid.querySelector('.' + SL.legal);
    if (!box || box.querySelector('.xd-legal-a')) return;
    var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT), n, last = null;
    while ((n = w.nextNode())) { if (n.nodeValue.indexOf(T.priv) > -1) last = n; }
    if (!last) return;
    var i = last.nodeValue.lastIndexOf(T.priv);
    var after = last.splitText(i);
    after.splitText(T.priv.length);
    var a = document.createElement('a');
    a.className = 'xd-legal-a';
    a.href = ROOT + 'policies/privacy-policy';
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = T.priv;
    after.parentNode.replaceChild(a, after);
  }

  /* ------------------------------- Schritt 1 ----------------------------- */
  function spiel(grid, slotEl) {
    styles();
    legalLink(grid);

    var wrap = document.createElement('div');
    wrap.className = 'xdw';
    wrap.setAttribute('data-xd', 'spiel');
    wrap.setAttribute('data-xd-state', 'pre');

    var pegs = '';
    for (var r = 0; r < ROWS; r++) {
      for (var h = (r % 2); h <= HALF; h += 2) {
        var t = SPEC[r + ':' + h] || 'N';
        var cls = t === 'R' ? 'wg r' : t === 'L' ? 'wg l' : ('peg' + (t === 'K' ? ' kk' : ''));
        pegs += '<span class="' + cls + '" data-c="' + r + ':' + h + '" style="left:' + xOf(h).toFixed(3) + '%;top:' + yOf(r).toFixed(3) + '%"></span>';
      }
    }
    var fins = '';
    for (var f = 1; f < N; f++) fins += '<span class="fin" style="left:' + ((f / N) * 100).toFixed(3) + '%"></span>';
    var slots = '';
    for (var s = 0; s < N; s++) slots += '<span class="slot' + (SLOTS[s].sp ? ' sp' : '') + '"><b>' + LAB[SLOTS[s].k] + '</b></span>';
    var ticks = '';
    for (var tk = 0; tk < N; tk++) ticks += '<span class="tick" style="left:' + xOf(tk * 2).toFixed(3) + '%"></span>';

    wrap.innerHTML =
      '<div data-step="spiel">'
      + '<div class="rail" data-rail tabindex="0" role="slider" aria-label="' + T.slider + '" aria-valuemin="1" aria-valuemax="7" aria-valuenow="4">'
      +   ticks + '<span class="thr"></span>'
      +   '<span class="hand" aria-hidden="true"><svg viewBox="0 0 24 32"><path d="M8.4 16.8V5.4C8.4 4.1 9.4 3 10.8 3s2.4 1.1 2.4 2.4V14.4h1.4c1.3 0 2.4 1 2.4 2.4v.6h1.2c1.3 0 2.4 1 2.4 2.4v4.3c0 3.8-3 6.9-6.8 6.9h-2.1c-2.3 0-4-1-5.2-2.9L2.9 22.3c-.7-1.1-.4-2.5.7-3.2 1.1-.7 2.5-.4 3.2.7l1.6 2.5z" fill="#030302" stroke="#ffffff" stroke-width="1.6" stroke-linejoin="round" paint-order="stroke"/></svg></span>'
      +   '<span class="hint" data-hint>' + T.hint + '</span>'
      + '</div>'
      + '<div class="board" data-board><span class="gd"></span>' + fins + pegs + '<span class="ball"></span></div>'
      + '<div class="slots" data-slots>' + slots + '</div>'
      + '<button type="button" class="go" data-throw>' + T.drop + '</button>'
      + '</div>'
      + '<div data-step="ergebnis" hidden>'
      +   '<div class="prize"><div class="a">' + T.won + '</div><div class="b" data-pv></div></div>'
      +   '<h3>' + T.h2 + '</h3>'
      +   '<p class="l">' + T.lead + '</p>'
      + '</div>';
    slotEl.appendChild(wrap);

    var rail = wrap.querySelector('[data-rail]'), thr = wrap.querySelector('.thr'), board = wrap.querySelector('[data-board]'),
        ball = wrap.querySelector('.ball'), guide = wrap.querySelector('.gd'), slotsEl = wrap.querySelector('[data-slots]'),
        hintEl = wrap.querySelector('[data-hint]'), btn = wrap.querySelector('[data-throw]');
    var zellen = {};
    [].forEach.call(wrap.querySelectorAll('[data-c]'), function (el) { zellen[el.getAttribute('data-c')] = el; });
    var pos = 3, busy = false, demoTimer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function demoStop() {
      if (demoTimer) { clearTimeout(demoTimer); demoTimer = null; }
      rail.classList.remove('demo');
      hintEl.classList.add('show');
    }
    function paint() {
      guide.style.left = xOf(pos * 2) + '%';
      thr.style.left = xOf(pos * 2) + '%';
      rail.setAttribute('aria-valuenow', pos + 1);
    }
    function vonX(clientX) {
      var b = rail.getBoundingClientRect();
      if (!b.width) return;
      var frac = (clientX - b.left) / b.width;
      var hh = Math.round(((frac * 100 - INSET) / SPAN) * HALF / 2) * 2;
      var p = Math.max(0, Math.min(N - 1, Math.round(hh / 2)));
      if (p !== pos) { pos = p; paint(); }
    }
    function blitz(r, h) {
      var el = zellen[r + ':' + h]; if (!el) return;
      el.classList.add('fl');
      setTimeout(function () { el.classList.remove('fl'); }, 150);
    }
    function spur(h, r) {
      var t = document.createElement('span');
      t.className = 'tr';
      t.style.left = xOf(h) + '%'; t.style.top = yOf(r) + '%';
      board.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('go'); });
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 620);
    }
    function zeigen(slot) {
      var won = SLOTS[slot];
      merken(won.k);
      var pv = wrap.querySelector('[data-pv]');
      pv.innerHTML = LAB[won.k];
      pv.className = 'b' + (won.sp ? ' sm' : '');
      wrap.querySelector('[data-step="spiel"]').hidden = true;
      wrap.querySelector('[data-step="ergebnis"]').hidden = false;
      wrap.setAttribute('data-xd-state', 'won');
      var inp = grid.querySelector('.' + SL.mail + ' input');
      if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
      track('reveal', { x_drop_stufe: won.k });
    }
    function werfen() {
      if (busy) return;
      busy = true;
      demoStop();
      btn.disabled = true; btn.textContent = T.busy;
      rail.classList.add('done');
      rail.setAttribute('aria-disabled', 'true');
      guide.style.opacity = '0';

      var h = pos * 2, pfad = [];
      for (var r = 0; r < ROWS; r++) {
        var t = SPEC[r + ':' + h] || 'N', von = h;
        if (t === 'K') h = ref(h + (Math.random() < 0.5 ? -3 : 3));
        else if (t === 'R') h = ref(h + 1);
        else if (t === 'L') h = ref(h - 1);
        else h = ref(h + (Math.random() < 0.5 ? -1 : 1));
        pfad.push({ r: r, von: von, zu: h, t: t });
      }
      var slot = h / 2;
      track('throw', { x_drop_position: pos + 1, x_drop_stufe: SLOTS[slot].k });

      ball.style.transition = 'none';
      ball.style.left = xOf(pos * 2) + '%';
      ball.style.top = '-10px';
      ball.classList.add('on');
      void ball.offsetWidth;

      if (reduce) {
        ball.style.transition = '';
        ball.style.left = xOf(slot * 2) + '%'; ball.style.top = '108%';
        slotsEl.children[slot].classList.add('hit');
        setTimeout(function () { zeigen(slot); }, 300);
        return;
      }
      function bewegen(x, y, dur) {
        ball.style.transition = 'left ' + dur + 'ms cubic-bezier(.45,0,.55,1),top ' + dur + 'ms cubic-bezier(.33,0,.85,.55)';
        ball.style.left = x + '%'; ball.style.top = y;
      }
      var t0 = 30, ERSTE = 190;
      setTimeout(function () { bewegen(xOf(pos * 2), yOf(0) + '%', ERSTE); }, t0);
      t0 += ERSTE;
      (function (hh) { setTimeout(function () { blitz(0, hh); }, t0); })(pos * 2);
      pfad.forEach(function (st) {
        var dur = st.t === 'K' ? 330 : 200;
        var letzte = st.r === ROWS - 1;
        setTimeout(function () {
          spur(st.von, st.r);
          bewegen(xOf(st.zu), letzte ? '112%' : yOf(st.r + 1) + '%', letzte ? 300 : dur);
        }, t0);
        t0 += letzte ? 300 : dur;
        if (!letzte) { (function (rr, hh) { setTimeout(function () { blitz(rr, hh); }, t0); })(st.r + 1, st.zu); }
      });
      setTimeout(function () {
        slotsEl.children[slot].classList.add('hit');
        if (navigator.vibrate) { try { navigator.vibrate(18); } catch (e) {} }
      }, t0);
      setTimeout(function () { zeigen(slot); }, t0 + 620);
    }

    rail.addEventListener('pointerdown', function (e) {
      if (busy) return;
      demoStop();
      rail.classList.add('grab');
      try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      vonX(e.clientX);
      e.preventDefault();
    });
    rail.addEventListener('pointermove', function (e) {
      if (busy || !rail.classList.contains('grab')) return;
      vonX(e.clientX);
    });
    rail.addEventListener('pointerup', function () {
      if (!rail.classList.contains('grab')) return;
      rail.classList.remove('grab');
      if (!busy) werfen();
    });
    rail.addEventListener('pointercancel', function () { rail.classList.remove('grab'); });
    rail.addEventListener('keydown', function (e) {
      if (busy) return;
      demoStop();
      if (e.key === 'ArrowLeft' && pos > 0) { pos--; paint(); e.preventDefault(); }
      else if (e.key === 'ArrowRight' && pos < N - 1) { pos++; paint(); e.preventDefault(); }
      else if (e.key === 'Enter' || e.key === ' ') { werfen(); e.preventDefault(); }
    });
    btn.addEventListener('click', werfen);

    paint();
    if (reduce) demoStop();
    else { rail.classList.add('demo'); demoTimer = setTimeout(demoStop, 13300); }
    track('view', {});
  }

  /* ------------------------------- Schritt 2 ----------------------------- */
  function aktivieren(c) {
    try {
      fetch(ROOT + 'discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'), { credentials: 'same-origin' })
        .catch(function () {});
    } catch (e) {}
  }
  function danke(grid, slotEl) {
    styles();
    var k = holen();
    var c = k ? code(k) : '';
    var wrap = document.createElement('div');
    wrap.className = 'xdw';
    wrap.setAttribute('data-xd', 'danke');
    if (!c) { slotEl.appendChild(wrap); return; }
    var cond = [minText(), T.once].filter(Boolean).join(' · ');
    cond = cond.charAt(0).toUpperCase() + cond.slice(1) + '.';
    wrap.innerHTML =
      '<p class="l" style="margin-top:0">' + T.act + '</p>'
      + '<div class="code"><div class="c"><div class="a">' + T.clab + '</div><div class="b" data-code></div></div>'
      + '<button type="button" class="cp" data-copy>' + T.copy + '</button></div>'
      + '<p class="cond">' + cond + '</p>';
    wrap.querySelector('[data-code]').textContent = c;
    slotEl.appendChild(wrap);
    var cp = wrap.querySelector('[data-copy]');
    cp.addEventListener('click', function () {
      function ok() { cp.textContent = T.copied; setTimeout(function () { cp.textContent = T.copy; }, 1800); }
      try {
        navigator.clipboard.writeText(c).then(ok, function () {});
      } catch (e) {
        try {
          var rg = document.createRange(); rg.selectNodeContents(wrap.querySelector('[data-code]'));
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(rg);
        } catch (er) {}
      }
    });
    aktivieren(c);
    var shop = grid.querySelector('.privy-widget-button');
    if (shop) shop.addEventListener('click', function () { track('redeem', { x_drop_stufe: k }); }, true);
    track('signup', { x_drop_stufe: k });
  }

  /* ------------------------------- Beobachter ---------------------------- */
  function scan(root) {
    var g1 = root.querySelectorAll('.' + SL.game);
    for (var i = 0; i < g1.length; i++) {
      var s = g1[i];
      if (s.getAttribute('data-xd-on')) continue;
      s.setAttribute('data-xd-on', '1');
      try { spiel(s.parentElement, s); } catch (e) {}
    }
    var g2 = root.querySelectorAll('.' + SL.code);
    for (var j = 0; j < g2.length; j++) {
      var s2 = g2[j];
      if (s2.getAttribute('data-xd-on')) continue;
      s2.setAttribute('data-xd-on', '1');
      try { danke(s2.parentElement, s2); } catch (e) {}
    }
  }
  var mo = null;
  function watch(w) {
    if (mo) return;
    scan(w);
    mo = new MutationObserver(function () { scan(w); });
    mo.observe(w, { childList: true, subtree: true });
  }
  function find() {
    var w = document.getElementById('privy-widget');
    if (w) { watch(w); return true; }
    return false;
  }
  function start() {
    if (find()) return;
    var n = 0;
    var bo = new MutationObserver(function () { if (find()) { bo.disconnect(); clearInterval(iv); } });
    bo.observe(document.body, { childList: true });
    var iv = setInterval(function () { if (find() || ++n > 180) { clearInterval(iv); bo.disconnect(); } }, 1000);
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
